import React, {useContext} from "react";
import {Box, Grid, TextField, InputAdornment, IconButton, Typography, Button} from "@mui/material";
import {ContentCopy} from '@mui/icons-material';
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "../../../../components/index";
import { isEmptyObject, removeEmpty } from "../../../../utils";
import { snackActions } from "../../../../utils/SnackBarUtils";
import copy from "clipboard-copy";
import {StoreContext} from "../../../../App";
import {Link} from "react-router-dom";


function UserProfessionalActivities({ user = {} }) {
  const {auth} = useContext(StoreContext);
  const authUser = auth.user;
  user = removeEmpty(user);

  if (
    isEmptyObject(user.YEDEBO)
  ) return (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Typography variant={"b"} component={"b"} sx={{ fontWeight: 500 }}>Нічого не знайдено</Typography>
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <Button component={Link} to={`/cabinet/users/${user._id}/edit`} variant={"contained"}>Додати</Button>
        </Box>
      </Box>
  );

  const copyPartnerLinkToClipboard = (data) => {
    copy(data);
    snackActions.success('Скопійовано');
  }

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
    >
      <Grid container sx={{ padding: "10px 0"}}>
        {authUser?._id === user._id && (
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}>
              <Button component={Link} to={`/cabinet/users/${user._id}/edit`}
                      variant={"contained"}>Редагувати</Button>
            </Grid>
        )}
        <Grid item sx={{ textAlign: "left" }} xs={12} sm={12} md={12}>
          {!isEmptyObject(user.YEDEBO) && (
            <Grid item>
              <Typography component={"b"} variant={"b"}>{"Досягнення у професійній діяльності (за останні 5 років)"}</Typography>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.availabilityOfPublications}
                  rows={15}
                  fullWidth={true}
                  helperText={'1. Наявність не менше п’яти публікацій у періодичних наукових виданнях, що включені до переліку фахових видань України, до наукометричних баз, зокрема Scopus, Web of Science Core Collection'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.availabilityOfPublications)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.availabilityOfOnePatent}
                  rows={15}
                  fullWidth={true}
                  helperText={'2. Наявність одного патенту на винахід або п’яти деклараційних патентів на винахід чи корисну модель, включаючи секретні, або наявність не менше п’яти свідоцтв про реєстрацію авторського права на твір'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.availabilityOfOnePatent)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.availabilityOfThePublishedTextbook}
                  rows={15}
                  fullWidth={true}
                  helperText={'3. Наявність виданого підручника чи навчального посібника (включаючи електронні) або монографії (загальним обсягом не менше 5 авторських аркушів), в тому числі видані у співавторстві (обсягом не менше 1,5 авторського аркуша на кожного співавтора)'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.availabilityOfThePublishedTextbook)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.availabilityOfPublishedTextbooks}
                  rows={15}
                  fullWidth={true}
                  helperText={'4. Наявність виданих навчально-методичних посібників/посібників для самостійної роботи здобувачів вищої освіти та дистанційного навчання, електронних курсів на освітніх платформах ліцензіатів, конспектів лекцій/практикумів/методичних вказівок/рекомендацій/ робочих програм, інших друкованих навчально-методичних праць загальною кількістю три найменування'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.availabilityOfPublishedTextbooks)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.defenseOfDissertationForScientificDegree}
                  rows={15}
                  fullWidth={true}
                  helperText={'5. Захист дисертації на здобуття наукового ступеня'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.defenseOfDissertationForScientificDegree)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.scientificGuidance}
                  rows={15}
                  fullWidth={true}
                  helperText={'6. Наукове керівництво (консультування) здобувача, який одержав документ про присудження наукового ступеня (прізвище, ім’я, по батькові дисертанта, здобутий науковий ступінь, спеціальність, назва дисертації, рік захисту, серія, номер, дата, ким виданий диплом)'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.scientificGuidance)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.participationCertificationOfScientificPersonnel}
                  rows={15}
                  fullWidth={true}
                  helperText={'7. Участь в атестації наукових кадрів як офіційного опонента або члена постійної спеціалізованої вченої ради, або члена не менше трьох разових спеціалізованих вчених рад'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.participationCertificationOfScientificPersonnel)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.performingFunctionsOfSupervisor}
                  rows={15}
                  fullWidth={true}
                  helperText={'8. Виконання функцій (повноважень, обов’язків) наукового керівника або відповідального виконавця наукової теми (проекту), або головного редактора/члена редакційної колегії/експерта (рецензента) наукового видання, включеного до переліку фахових видань України, або іноземного наукового видання, що індексується в бібліографічних базах'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.performingFunctionsOfSupervisor)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.workMemberOfExpertCouncil}
                  rows={15}
                  fullWidth={true}
                  helperText={'9. Робота у складі експертної ради з питань проведення експертизи дисертацій МОН або у складі галузевої експертної ради як експерта Національного агентства із забезпечення якості вищої освіти, або у складі Акредитаційної комісії, або міжгалузевої експертної ради з вищої освіти Акредитаційної комісії, або трьох експертних комісій МОН/зазначеного Агентства, або Науково-методичної ради/науково-методичних комісій (підкомісій) з вищої або фахової передвищої освіти МОН, наукових/науково-методичних/експертних рад органів державної влади та органів місцевого самоврядування, або у складі комісій Державної служби якості освіти із здійснення планових (позапланових) заходів державного нагляду (контролю)'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.workMemberOfExpertCouncil)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.internationalScientificProjects}
                  rows={15}
                  fullWidth={true}
                  helperText={'10. Участь у міжнародних наукових та/або освітніх проектах, залучення до міжнародної експертизи, наявність звання “суддя міжнародної категорії”'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.internationalScientificProjects)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.scientificConsultingOfEnterprises}
                  rows={15}
                  fullWidth={true}
                  helperText={'11. Наукове консультування підприємств, установ, організацій не менше трьох років, що здійснювалося на підставі договору із закладом вищої освіти (науковою установою)'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.scientificConsultingOfEnterprises)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.presenceOfApprobation}
                  rows={15}
                  fullWidth={true}
                  helperText={'12. Наявність апробаційних та/або науково-популярних, та/або консультаційних (дорадчих), та/або науково-експертних публікацій з наукової або професійної тематики загальною кількістю не менше п’яти публікацій'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.presenceOfApprobation)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.conductingTrainingSessions}
                  rows={15}
                  fullWidth={true}
                  helperText={'13. Проведення навчальних занять із спеціальних дисциплін іноземною мовою (крім дисциплін мовної підготовки) в обсязі не менше 50 аудиторних годин на навчальний рік'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.conductingTrainingSessions)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.studentGuide}
                  rows={15}
                  fullWidth={true}
                  helperText={'14. Керівництво студентом, який зайняв призове місце на I або ІІ етапі Всеукраїнської студентської олімпіади (Всеукраїнського конкурсу студентських наукових робіт), або робота у складі організаційного комітету / журі Всеукраїнської студентської олімпіади (Всеукраїнського конкурсу студентських наукових робіт), або керівництво постійно діючим студентським науковим гуртком / проблемною групою; керівництво студентом, який став призером або лауреатом Міжнародних, Всеукраїнських мистецьких конкурсів, фестивалів та проектів, робота у складі організаційного комітету або у складі журі міжнародних, всеукраїнських мистецьких конкурсів, інших культурно-мистецьких проектів (для забезпечення провадження освітньої діяльності на третьому (освітньо-творчому) рівні); керівництво здобувачем, який став призером або лауреатом міжнародних мистецьких конкурсів, фестивалів, віднесених до Європейської або Всесвітньої (Світової) асоціації мистецьких конкурсів, фестивалів, робота у складі організаційного комітету або у складі журі зазначених мистецьких конкурсів, фестивалів); керівництво студентом, який брав участь в Олімпійських, Параолімпійських іграх, Всесвітній та Всеукраїнській Універсіаді, чемпіонаті світу, Європи, Європейських іграх, етапах Кубка світу та Європи, чемпіонаті України; виконання обов’язків тренера, помічника тренера національної збірної команди України з видів спорту; виконання обов’язків головного секретаря, головного судді, судді міжнародних та всеукраїнських змагань; керівництво спортивною делегацією; робота у складі організаційного комітету, суддівського корпусу'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.studentGuide)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.guideTheStudent}
                  rows={15}
                  fullWidth={true}
                  helperText={'15. Керівництво школярем, який зайняв призове місце III—IV етапу Всеукраїнських учнівських олімпіад з базових навчальних предметів, II—III етапу Всеукраїнських конкурсів-захистів науково-дослідницьких робіт учнів — членів Національного центру “Мала академія наук України”; участь у журі III—IV етапу Всеукраїнських учнівських олімпіад з базових навчальних предметів чи II—III етапу Всеукраїнських конкурсів-захистів науково-дослідницьких робіт учнів — членів Національного центру “Мала академія наук України” (крім третього (освітньо-наукового/освітньо-творчого) рівня)'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.guideTheStudent)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.presenceOfStatusOfParticipant}
                  rows={15}
                  fullWidth={true}
                  helperText={'16. Наявність статусу учасника бойових дій (для вищих військових навчальних закладів, закладів вищої освіти із специфічними умовами навчання, військових навчальних підрозділів закладів вищої освіти)'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.presenceOfStatusOfParticipant)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.participationInInternationalOperations}
                  rows={15}
                  fullWidth={true}
                  helperText={'17. Участь у міжнародних операціях з підтримання миру і безпеки під егідою Організації Об’єднаних Націй (для вищих військових навчальних закладів, закладів вищої освіти із специфічними умовами навчання, військових навчальних підрозділів закладів вищої освіти)'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.participationInInternationalOperations)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.participationInInternationalMilitaryExercises}
                  rows={15}
                  fullWidth={true}
                  helperText={'18. Участь у міжнародних військових навчаннях (тренуваннях) за участю збройних сил країн — членів НАТО (для вищих військових навчальних закладів, військових навчальних підрозділів закладів вищої освіти)'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.participationInInternationalMilitaryExercises)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.activityBySpecialty}
                  rows={15}
                  fullWidth={true}
                  helperText={'19. Діяльність за спеціальністю у формі участі у професійних та/або громадських об’єднаннях'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.activityBySpecialty)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item sx={{ padding: "10px 0" }}>
                <TextField
                  value={user.YEDEBO.practicalExperience}
                  rows={15}
                  fullWidth={true}
                  helperText={'20. Досвід практичної роботи за спеціальністю (спеціалізацією)/професією не менше п’яти років (крім педагогічної, науково-педагогічної, наукової діяльності) із зазначенням посади та строку роботи на цій посаді. Організаційна робота у закладах освіти на посадах керівника (заступника керівника) закладу освіти/інституту/факультету/відділення (наукової установи)/ філії/кафедри або іншого відповідального за підготовку здобувачів вищої освіти підрозділу/відділу (наукової установи)/навчально-методичного управління (відділу)/лабораторії/іншого навчально-наукового (інноваційного) структурного підрозділу/вченого секретаря закладу освіти (факультету, інституту)/відповідального секретаря приймальної комісії та його заступника'}
                  multiline={true}
                  sx={{flexDirection: 'column-reverse'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" onClick={() => copyPartnerLinkToClipboard(user.YEDEBO.practicalExperience)}>
                        <IconButton edge="end" color="primary">
                          <ContentCopy/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </ErrorBoundary>
  );
}

export default UserProfessionalActivities;
